import { CustomerInvitationSortOption } from '@rematter/frontend-lib-api-client';

import {
  CustomerPortalUserRecord,
  CustomerPortalUserStatus,
  InvitationStatus,
} from '../types';

import { createQueryHook } from '~/shared/providers/api';

export interface CustomerInvitationsQueryParams {
  searchTerm?: string;
  sorting?: CustomerInvitationSortOption[];
  limit?: number;
  offset?: number;
}

export interface CustomerInvitationsQueryResult {
  users: CustomerPortalUserRecord[];
  total: number;
}

export const useCustomerInvitationsQuery = createQueryHook(
  'settings.customerPortal.invitations',
  (params: CustomerInvitationsQueryParams) => ({
    customerInvitations: {
      __args: {
        filter: {
          invitationStatuses: ['PENDING', 'ACCEPTED'],
          includeAccount: true,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 20,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        email: true,
        invitationStatus: true,
        accountId: true,
        sentAt: true,
        acceptedAt: true,
        account: {
          id: true,
          name: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): CustomerInvitationsQueryResult => ({
      users:
        data?.customerInvitations.entries.map((inv) => {
          const status =
            inv.invitationStatus?.toLowerCase() as InvitationStatus;
          const userStatus: CustomerPortalUserStatus =
            status === 'accepted' ? 'active' : 'invite_sent';

          return {
            id: inv.id,
            name: inv.email,
            company: inv.account?.name ?? '',
            email: inv.email,
            phoneNumber: null,
            status: userStatus,
            invitationStatus: status,
            accountId: inv.accountId,
          };
        }) ?? [],
      total: data?.customerInvitations.page.total ?? 0,
    }),
  },
);
